import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconFamily(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 52 52",
        xmlSpace: "preserve",
        enableBackground: "new 0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.Icon-family_svg__st0{display:none}.Icon-family_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st2{display:inline}.Icon-family_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-family_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-family_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-family_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-family_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-family_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-family_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-family_svg__st17{fill:none}'), /*#__PURE__*/React.createElement("g", {
        id: "Icon-family_svg__stroke",
        className: "Icon-family_svg__st0"
      }, /*#__PURE__*/React.createElement("g", {
        className: "Icon-family_svg__st2"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        className: "Icon-family_svg__st10",
        d: "M21,35.1667C21,35.5417,21.4583,36,21.8333,36h8.3333C30.5628,35.971,31,35.5312,31,35.1667V31 c0-1.6667-1.125-3-3-3h-4c-1.875,0-3,1.1315-3,3V35.1667z"
      }), /*#__PURE__*/React.createElement("polyline", {
        className: "Icon-family_svg__st10",
        points: "22,36.5 22,41 30,41 30,36.5  "
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 26,
        y1: 40,
        x2: 26,
        y2: 39
      }), /*#__PURE__*/React.createElement("circle", {
        className: "Icon-family_svg__st7",
        cx: 26,
        cy: 22,
        r: 3
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 24,
        y1: 42,
        x2: 24,
        y2: 47
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 28,
        y1: 42,
        x2: 28,
        y2: 47
      })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        className: "Icon-family_svg__st10",
        d: "M5,26c0,0.45,0.55,1,1,1h10c1,0,1-0.25,1-1v-8c0-2-1.75-4-4-4H9c-2.25,0-4,1.7578-4,4V26z"
      }), /*#__PURE__*/React.createElement("polyline", {
        className: "Icon-family_svg__st10",
        points: "7,27.5 7,47 15,47 15,27.5  "
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 11,
        y1: 46,
        x2: 11,
        y2: 32
      }), /*#__PURE__*/React.createElement("circle", {
        className: "Icon-family_svg__st7",
        cx: 11,
        cy: 8,
        r: 3
      })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        className: "Icon-family_svg__st10",
        d: "M35,26c0,0.45,0.55,1,1,1h10c1,0,1-0.25,1-1v-8c0-2-1.75-4-4-4h-4c-2.25,0-4,1.7578-4,4V26z"
      }), /*#__PURE__*/React.createElement("polyline", {
        className: "Icon-family_svg__st10",
        points: "37,27.5 35,36 47,36 45,27.5  "
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 39,
        y1: 37,
        x2: 39,
        y2: 47
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-family_svg__st3",
        x1: 43,
        y1: 37,
        x2: 43,
        y2: 47
      }), /*#__PURE__*/React.createElement("circle", {
        className: "Icon-family_svg__st7",
        cx: 41,
        cy: 8,
        r: 3
      })))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-family_svg__filled"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M43.0001,13h-4c-2.8037,0-5,2.1963-5,5v8c0,0.9623,0.9006,1.8965,1.8586,1.9833L35.8549,28h10.2905l-0.0025-0.0107 c1.6978-0.0572,1.8572-1.0496,1.8572-1.9893v-8C48.0001,15.3369,45.6637,13,43.0001,13z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M38.0001,47c0,0.5527,0.4478,1,1,1s1-0.4473,1-1v-8h-2V47z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M45.0001,37h2c0.3057,0,0.5942-0.1396,0.7837-0.3789c0.1899-0.2393,0.2598-0.5527,0.1899-0.8506L46.616,30H35.3842 l-1.3577,5.7705c-0.0698,0.2979,0,0.6113,0.1899,0.8506C34.4059,36.8604,34.6945,37,35.0001,37h2h1h2h2h2H45.0001z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M42.0001,47c0,0.5527,0.4478,1,1,1s1-0.4473,1-1v-8h-2V47z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 41.0001,
        cy: 8,
        r: 4
      }), /*#__PURE__*/React.createElement("path", {
        d: "M27,47c0,0.5527,0.4478,1,1,1s1-0.4473,1-1v-3h-2V47z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M23,47c0,0.5527,0.4478,1,1,1s1-0.4473,1-1v-3h-2V47z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M30,42c0.5522,0,1-0.4473,1-1v-3H21v3c0,0.5527,0.4478,1,1,1h1h2h2h2H30z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M32,35.167V31c0-2.3174-1.6821-4-4-4h-4c-2.4297,0-4,1.5703-4,4v4.167c0,0.2908,0.0988,0.575,0.2513,0.833h11.4973 C31.9012,35.7419,32,35.4578,32,35.167z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 26,
        cy: 22,
        r: 4
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15,48c0.5522,0,1-0.4473,1-1V30H6v17c0,0.5527,0.4478,1,1,1h3V33c0-0.5527,0.4478-1,1-1s1,0.4473,1,1v15H15z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6,28h10c1.8452,0,2-1.0322,2-2v-8c0-2.6631-2.3364-5-5-5H9c-2.8037,0-5,2.1963-5,5v8C4,27.0098,4.9907,28,6,28z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 11,
        cy: 8,
        r: 4
      }))));
    }
  }));
}
export default SvgIconFamily;